export class DocumentosCierreCaja{
    codigoAeroplanta: string;
    facturasIds: string[];
    totalIngresoEfectivo: number;
    responsable: string;
}